<div class="col-xxl-12 " *ngIf="totalRegistros == 0 || isLoading">
    <div class="card mb-0">
        <div class="card-body ">
            <div class="py-4 text-center" *ngIf="totalRegistros == 0 && !isLoading">
                <div>
                    <lord-icon src="https://cdn.lordicon.com/msoeawqm.json"
                               trigger="loop" colors="primary:#405189,secondary:#0ab39c"
                               style="width:72px;height:72px">
                    </lord-icon>
                </div>
                <div class="mt-4">
                    <h4 class="text-success">No se encontrarón resultados</h4>
                </div>
            </div>
            <div class="py-4 text-center" *ngIf="isLoading">
                <div>
                    <lord-icon src="https://cdn.lordicon.com/uetqnvvg.json"
                               trigger="loop" colors="primary:#405189,secondary:#0ab39c"
                               style="width:100px;height:100px">
                    </lord-icon>
                </div>
                <div class="mt-4">
                    <h4 class="text-success">Buscando resultados</h4>
                </div>
            </div>
        </div>
    </div>
</div>
